import script from "./QRCodeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./QRCodeDialog.vue?vue&type=script&setup=true&lang=js"

import "./QRCodeDialog.vue?vue&type=style&index=0&id=1825995c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1825995c"]])

export default __exports__